//
// Colors used in Chart.js charts
//
export default [
  'rgba(0, 136, 221, .8)',
  'rgba(103, 194, 58, .8)',
  'rgba(235, 158, 5, .8)',
  'rgba(250, 85, 85, .8)',
  'rgba(206, 87, 250, .8)',
  'rgba(139, 147, 154, .75)',
  'rgba(139, 147, 154, .6)',
  'rgba(139, 147, 154, .55)',
  'rgba(139, 147, 154, .4)',
  'rgba(139, 147, 154, .25)',
  'rgba(139, 147, 154, .1)'
];
